import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { ProductFilterService } from '../Services/productfilter';
import { ProductFilter } from '../Models/filter';

@Component({
  selector: 'product-filter',
  templateUrl: '../Templates/product.filter.html',
  styleUrls: ['../Styles/product.filter.css'],
})


export class ProductFilterComponent implements OnInit {

  @Input()
  public filter: ProductFilter;

  @Output()
  public filterChange: EventEmitter<ProductFilter> = new EventEmitter();

  filters: { [index:string]:string } = {};

  constructor(
    public productFilterService: ProductFilterService,
  ) {
  }

  ngOnInit() {
    this.loadSizes();
  }

  loadSizes() {
    // only if exactly one category is checked, load the corresponding sizes
    // it's too confusing to have e.g. shoe sizes + dress sizes in one filter
    if (this.filter['category'].length !== 1) {
      this.productFilterService.size = []; // reset size filter
      this.filter.size = [];
    } else {
      this.productFilterService.getFilteredSizes(this.filter['category']);
    }
  }

  setFilter(e): void {

    if (e.target.checked) {
      this.filter.setval(e.target.name, e.target.value);
    } else {
      this.filter.unsetval(e.target.name, e.target.value);
    }

    this.loadSizes();

    // Always clear page setting...
    this.filter.clear('page');

    this.filterChange.next(this.filter);
  }

  public isChecked(category, id: number) {
    return this.filter[category].indexOf(id) > -1;
  }

  getFilterName(filterCategory: string, id: number): string {
    return this.productFilterService.getFilterName(filterCategory, id);
  }

  /**
   * Filter the given 'filter' by the value provided.
   */
  public doFilter(filter, part): void {

    this.filters[filter] = part;
  }

  /**
   * If a filter value is set for this filter category, test on regexp
   */
  public showFilterValue(filter, value): boolean {

    if (this.filters[filter]) {
      return new RegExp(this.filters[filter], "i").test(value);
    } else {
      return true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/Components/product.filter.ts